import { Box, Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

export default function SearchBar({ onSearch, placeholder, resetSignal, onApply }) {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue("");
    onSearch("");
  }, [resetSignal, onSearch]);

  const handleClickSearch = () => {
    const trimmedValue = value.trim();
    onSearch(trimmedValue);
    if (onApply) {
      onApply(trimmedValue);
    }
  };

  return (
    <Box
      display="flex"
      gap={1}
      alignItems="center"
      sx={{ flex: 1, minWidth: 300 }}
    >
      <TextField
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleClickSearch();
          }
        }}
        sx={{ flex: 1, minWidth: 260 }}
        fullWidth
      />

      <Button
        variant="contained"
        onClick={handleClickSearch}
        sx={{ whiteSpace: "nowrap", backgroundColor: '#0053FF' }}
      >
        Search
      </Button>
    </Box>
  );
}